import classNames from "classnames";
import React from "react";

import { QuickSearchItem } from "../models";

export const LocatorQuickSearch = (props: {
    items: QuickSearchItem[];
    selectedItem: string | undefined;
}) => (
    <nav className="quicksearch__nav">
        {props.items.map((item) => (
            <div
                key={item.id}
                className={classNames({
                    "quicksearch__nav-item": true,
                    "al-store-locator__nav-item--quicksearch": true,
                    "quicksearch__nav-item--selected":
                        props.selectedItem === item.id,
                })}
            >
                <a
                    className={`quicksearch__nav-button ${item.labelClassName}`}
                    href={item.href}
                >
                    <div className="quicksearch__nav-img-wrapper">
                        <img
                            className="quicksearch__nav-img"
                            alt={item.imgAlt}
                            src={item.imgSrc}
                        />
                    </div>
                    <h4 className="quicksearch__nav-title">{item.title}</h4>
                </a>
                <div className="quicksearch__nav-descript">{item.descr}</div>
            </div>
        ))}
    </nav>
);
